import { render } from "./columnarStacking.vue?vue&type=template&id=214a13a1&scoped=true"
import script from "./columnarStacking.vue?vue&type=script&lang=js"
export * from "./columnarStacking.vue?vue&type=script&lang=js"

import "./columnarStacking.vue?vue&type=style&index=0&id=214a13a1&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-214a13a1"]])

export default __exports__